import axios from "axios";
import { toast } from "react-hot-toast";
import { useAuth } from "../components/features/AuthContext";

/**
 * Function to handle API requests with loading and error handling.
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
 * @param {string} url - API endpoint URL
 * @param {object} [data] - Request body (for POST/PUT)
 * @returns {Promise<any>} - API response
 */
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
export const host = isLocalhost ? "http://localhost:5001/" : "https://api.delightrgext.xyz/";

export async function ApiRequest(method, endpoint, data = null, headers = null) {
  const toastId = toast.loading("Processing...");
  try {
    // Show loader/snackbar for request initiation
    // const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    // const host = false ? "http://localhost:5001/" : "c";
    const url = host + endpoint

    const response = await axios({
      method,
      url,
      data,
      headers: headers == null ? { "Content-Type": "application/json" } : headers,
    });

    // Dismiss loader and show success message
    toast.success(response.data.message ?? "Success!", { id: toastId });
    return response.data;
  } catch (error) {
    // Handle API error and show snackbar
    toast.error(error.response?.data?.message || error.message || "Something went wrong", { id: toastId });
    return error.response?.data || error.message || "Something went wrong";
  }
}


export async function ApiRequestBlob(method, endpoint) {
  const toastId = toast.loading("Processing...");
  try {
    // Show loader/snackbar for request initiation
    // const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    // const host = isLocalhost ? "http://localhost:5001/" : "https:delightrgext.xyz/api/";
    const url = host + endpoint

    const response = await axios({
      method,
      url,
      headers: { "Content-Type": "application/json" },
      responseType: "blob"
    });

    // Dismiss loader and show success message
    toast.success(response.data.message ?? "Success!", { id: toastId });
    return response.data;
  } catch (error) {
    // Handle API error and show snackbar
    toast.error(error.response?.data?.message || error.message || "Something went wrong", { id: toastId });
    return error.response?.data || error.message || "Something went wrong";
  }
}

export async function ApiRequestNoLoder(method, endpoint, data = null, headers = null) {
  try {
    // Show loader/snackbar for request initiation
    // const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    // const host = localStorage.getItem("apiHost") || "http://localhost:5000/";
    const url = host + endpoint

    const response = await axios({
      method,
      url,
      data,
      headers: headers == null ? { "Content-Type": "application/json" } : headers,
    });

    // Dismiss loader and show success message
    return response.data;
  } catch (error) {
    // Handle API error and show snackbar
    return error.response?.data || error.message || "Something went wrong";
  }
}
